import { combineReducers } from 'redux'

import list from './adminUserListReducers'
import edit from './adminUserEditReducers'
import view from './adminUserViewReducers'
import reports from './adminUserReportReducers'
import groupings from './adminUserGroupReducers'
import passwordReset from './adminUserPasswordReducers'
import invite from './adminInviteReducers'
import remove from './adminUserRemoveReducers'
import assignments from './adminAssignmentReducers'

import {
  GROUP_LIST,
  REPORT_GROUP_DEFAULT_DATA_LOAD
} from '../../actions/admin/adminUserActions'
import * as actions from '../../actions/admin/adminUserActions'
import * as h2Api from '../../h2Api'
import combine from '../../reducers/admin/adminUserCombineReducers'

export default combineReducers({
  list,
  edit,
  view,
  groupings,
  groupingsRequest: h2Api.restReducer(GROUP_LIST),
  passwordReset,
  remove,
  reports,
  userReportsRequest: h2Api.restReducer(REPORT_GROUP_DEFAULT_DATA_LOAD),
  invite,
  assignments,
  quotaRequest: h2Api.restReducer(actions.MANAGER_QUOTA),
  combine
})
